<template>
	<div class="layout-home">
		<banner-top class="mobile"/>
		<banner 
			@open-modal="openModal"
			:cellar="cellar"
			:count="count"/>
		<section-steps />
		<section-help />
		<new-footer />
		<second-footer />
		<modal-cellars
			@close="closeDialog"
			:dialog="dialog"
			:cellars="cellar.ecommerce"/>
	</div>
</template>
<script>
import banner from '@/components/home/banner';
import sectionOrders from '@/components/home/section-orders';
import sectionInvoice from '@/components/home/section-invoice';
import sectionCreate from '@/components/home/section-create';
import sectionHelp from '@/components/home/section-help';
import sectionWarehouse from '@/components/home/section-warehouse';
import sectionFooter from '@/components/home/section-footer';
import sliderOrder from '@/components/home/slider-order';
import sectionLook from '@/components/home/section-look';
import modalCellars from '@/components/home/modal-cellars';
import sectionSteps from '@/components/home/section-steps';
import newFooter from '@/components/home/new-footer';
import bannerTop from '@/components/home/banner-top';
import secondFooter from '@/components/home/second-footer';

function openModal() {
	this.dialog = true;
}

function closeDialog() {
	this.dialog = false;
}

async function loadData() {
	try {
		const { data: response } = await this.$http.get(`ecommerce-coupon/${process.env.COUPON}`);
		this.cellar = response;
	} catch (error) {
		this.showGenericError();
	}
}

async function loadCount() {
	const typeCode = process.env.TYPE_CODE;
	const body = {
		companyId: process.env.COMPANY_ID,
		templateCode: process.env.TEMPLATE_CODE,
	};
	try {
		const { data: response } = await this.$httpNotification.post(`notifications/${typeCode}/count`, body);
		this.count = response.count;
	} catch (error) {
		this.showGenericError();
	}
}

function created() {
	this.loadData();
	this.loadCount();
}

function data() {
	return {
		rows: [],
		dialog: false,
		cellar: {},
		count: 0,
	};
}

export default {
	name: 'page-home',
	data,
	created,
	components: {
		banner,
		bannerTop,
		sectionOrders,
		sectionInvoice,
		sectionCreate,
		sectionHelp,
		sectionWarehouse,
		sectionFooter,
		sliderOrder,
		sectionLook,
		modalCellars,
		sectionSteps,
		newFooter,
		secondFooter,
	},
	methods: {
		closeDialog,
		openModal,
		loadData,
		loadCount,
	},
};
</script>
<style lang="scss" scoped>
	.mobile {
		@media (max-width: 600px) {
			display: none !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/page-home.vue